import CardSelfCom from "./card_self_com";

const {ccclass,property} = cc._decorator;

@ccclass
export default class CardCalculateCom extends cc.Component{

    private labelList : cc.Label[] = [];

    protected onEnable(){
      
        this.labelList = this.node.getComponentsInChildren(cc.Label); 
        
        this.labelList.forEach(label => {
            
            label.string = " ";
        });
    }

    public onDisable(){

        this.labelList.forEach(element => {
            element.string = " ";
        });
    }

    public updateCalculate(list : number[]){

        for (let index = 0; index < 3; index++) {
            const value = list[index];
            if (value) {
                this.labelList[index].string = value.toString();    
            }
            else{
                this.labelList[index].string = " ";
            }                        
        }

        let result : number = 0;
        list.forEach(element => {
          
            result += element;
            
        });

        this.labelList[3].string = result > 0 ? result.toString() : " ";
    }


}
